// extracted by mini-css-extract-plugin
export default {"button":"DomainList-button_mzbv1","suggestionRows":"DomainList-suggestionRows_tdIrJ"};